/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
"use strict";
var ContentRef = (function () {
    function ContentRef(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
    return ContentRef;
}());
exports.ContentRef = ContentRef;



//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/~/ng2-bootstrap/component-loader/content-ref.class.js
// module id = 493
// module chunks = 1